import { render } from "./TheHero.vue?vue&type=template&id=1931af26"
import script from "./TheHero.vue?vue&type=script&lang=js"
export * from "./TheHero.vue?vue&type=script&lang=js"

import "./TheHero.vue?vue&type=style&index=0&id=1931af26&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__